import React from "react";
import "./formItem.scss";
import { ItemFieldFragment } from "../../../../../generated/nuggetKmsApi/graphql";
import { ItemField } from "./itemField/ItemField";
import {
	useGetSubmissionItemFieldsRecoil,
	useSetSubmissionItemFieldsRecoil,
} from "../../formDetail.service";
import ParseHTMLContent from "../../../../../components/ParseHTMLContent/ParseHTMLContent";
interface FormItemProps {
	name: string;
	description: string;
	itemFields: ItemFieldFragment[];
}

export const FormItem: React.FC<FormItemProps> = ({ name, description, itemFields }) => {
	const { getSubmissionItemField } = useGetSubmissionItemFieldsRecoil();
	const { setSubmissionItemField } = useSetSubmissionItemFieldsRecoil();
	return (
		<div className="form-item">
			<div>
				<h1 id="FormItem-header">
					<ParseHTMLContent htmlString={name} />
				</h1>
				<p>
					<ParseHTMLContent htmlString={description} />
				</p>
			</div>
			<div className="input-container">
				{itemFields.map((field, index) => {
					return (
						<ItemField
							key={index}
							itemField={field}
							value={getSubmissionItemField(field.id)?.value ?? null}
							onChange={(value) => {
								setSubmissionItemField({
									itemFieldId: field.id,
									value,
								});
							}}
						/>
					);
				})}
			</div>
		</div>
	);
};
